import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';

export function getInsightSetOrganisations(insightSetId, isAllocatedTo = true, excludeArchived = true) {
  return function(dispatch, getState) {
    const endpoint = '/organisations';
    const options = {
      method: "GET",
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        isAllocatedTo,
        insightSetId,
        excludeArchived
      }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        const organisations = response.data.organisations;
        const type = isAllocatedTo ? 'UPDATE_CURRENT_INSIGHTSET_ALLOCATED_ORGANISATIONS' : 'UPDATE_CURRENT_INSIGHTSET_UNALLOCATED_ORGANISATIONS';
        dispatch({ type, organisations });
      },
      error => dispatch(APIError(error, 'Error getting currentInsightSet Organisations'))
    );
  }
}

export function addOrganisationToInsightSet(insightSetId, organisationId) {
  return function(dispatch, getState) {
    const endpoint = '/insightset/membership/organisation';
    const options = {
      method: 'POST',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: {
        organisationId,
        insightSetId
      }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        // update both allocated and unallocated orgs
        dispatch(getInsightSetOrganisations(insightSetId, true));
        dispatch(getInsightSetOrganisations(insightSetId, false));
        return response;
      },
      error => dispatch(APIError(error, 'Error adding Organisation to currentInsightSet'))
    );
  }
}

export function removeOrganisationFromInsightSet(insightSetId, organisation) {
  return function(dispatch, getState) {
    const endpoint = `/insightset/membership/organisation/${organisation.membershipId}`;
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: { isArchived: true }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        // update both allocated and unallocated orgs
        dispatch(getInsightSetOrganisations(insightSetId, true));
        dispatch(getInsightSetOrganisations(insightSetId, false));
        return response;
      },
      error => dispatch(APIError(error, 'Error removing Organisation from currentInsightSet'))
    );
  }
}


// WEBPACK FOOTER //
// ./src/actions/insightSets/organisationCreators.js